import { useState } from 'react';
import { motion } from 'framer-motion';
import axios from 'axios';
import { Lock, ShieldCheck } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const formatError = (detail) => {
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(' ');
  return 'Unable to sign in. Please try again.';
};

export const AdminLogin = ({ onSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { username, password });
      onSuccess(data.access_token);
    } catch (err) {
      setError(formatError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-[#0B1F3B] px-4 pt-24" data-testid="admin-login-page">
      <motion.form onSubmit={submit} initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="w-full max-w-md rounded-[2rem] border border-white/10 bg-white/5 p-10 shadow-2xl backdrop-blur-xl" data-testid="admin-login-form">
        <div className="mb-8 flex items-center gap-3 text-[#C5A880]"><ShieldCheck className="h-6 w-6" /><span className="font-tech text-xs uppercase tracking-[0.28em]">Mandate operations</span></div>
        <h1 className="font-display text-4xl font-semibold tracking-tight text-white">Restricted access</h1>
        <p className="mt-3 text-sm text-white/55">Sign in to view inquiries, notes and conversion analytics.</p>
        <div className="mt-8 grid gap-4">
          <Input value={username} onChange={(e) => setUsername(e.target.value)} placeholder="Admin ID" autoComplete="username" required className="h-12 rounded-full border-white/15 bg-white/10 px-5 text-white placeholder:text-white/35" data-testid="admin-login-username" />
          <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" autoComplete="current-password" required className="h-12 rounded-full border-white/15 bg-white/10 px-5 text-white placeholder:text-white/35" data-testid="admin-login-password" />
        </div>
        {error && <p className="mt-4 rounded-2xl bg-red-500/15 px-4 py-3 text-sm text-red-200" data-testid="admin-login-error">{error}</p>}
        <Button type="submit" disabled={loading} className="mt-6 h-12 w-full rounded-full bg-[#C5A880] text-[#0B1F3B] hover:bg-[#EFE6D8]" data-testid="admin-login-submit"><Lock className="h-4 w-4" />{loading ? 'Signing in...' : 'Sign in'}</Button>
      </motion.form>
    </main>
  );
};
